export const change = () => document.body.classList.add('bgChange');

export const revert = () => document.body.classList.remove('bgChange');
